import React from 'react';
import { Col, Row, Table } from 'antd';
import { useTranslation } from 'react-i18next';

const StorageReportSection = ({ data, storageCamera }) => {
  const { t } = useTranslation();

  const column = [
    {
      title: t('Storage days count'),
      dataIndex: 'dayStorage',
      key: 'dayStorage',
    },
    {
      title: t('Camera count'),
      dataIndex: 'numberCamera',
      key: 'numberCamera',
    },
  ];

  if (!data?.cameraStatisticStorage) {
    return null;
  }

  return (
    <div>
      <div className="section-title">{t('CAMERA STORAGE STATISTICS')}</div>
      <Row>
        <Col span={24}>
          <Table
            size="small"
            columns={column}
            pagination={{
              total: storageCamera?.length || 0,
              position: ['bottomRight'],
              pageSizeOptions: [10, 20, 50, 100, 200, 400],
            }}
            dataSource={storageCamera}
          />
        </Col>
      </Row>
    </div>
  );
};

export default StorageReportSection;
